window.NotifyAwin = function(notiInfo) {

	var masterTagExists
	var devMode;
	var prodMode;

	function InitValues() {
		masterTagExists = (typeof AWIN != "undefined") && (typeof AWIN.Tracking != "undefined");
		devMode         = notiInfo.config.devMode;
		prodMode        = !devMode;
	}

	function TriggerConversionTag() {
		if (masterTagExists) {
			var objSale                 = notiInfo.conversionTag;
			AWIN.Tracking.Sale          = {};
			AWIN.Tracking.Sale.amount   = objSale.amount;
			AWIN.Tracking.Sale.channel  = objSale.channel;
			AWIN.Tracking.Sale.orderRef = objSale.orderRef;
			AWIN.Tracking.Sale.parts    = objSale.parts;
			AWIN.Tracking.Sale.currency = objSale.currency;
			AWIN.Tracking.Sale.voucher  = objSale.voucher;
			AWIN.Tracking.Sale.test     = objSale.test;
			AWIN.Tracking.run();
		}
	}

	function TriggerConversionPixel() {
		var awPixel = new Image(0, 0);
		awPixel.src = notiInfo.pixelUrl;
	}

	function TriggerNotifications() {
		if (prodMode) {
			TriggerConversionTag();
			TriggerConversionPixel();
		}
	}

	function TriggerNotificationsSafely() {
		try {
			InitValues();
			TriggerNotifications();
		} catch (e) {
			console.log(e);
		}
	}

	TriggerNotificationsSafely();
}